export default "__VITE_ASSET__DHoiXMSU__"